import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import FavoriteResultCard from '../FavoriteResultCard/FavoriteResultCard';
import mapFavoritesData from './mapFavoritesData';

const FavoritesList = ({ data }) => {
  const { t } = useTranslation();
  
  if (!data || data.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <p>{t("no_favorites_found", "No saved items found")}</p>
      </div>
    );
  }

  return (
    <div className="space-y-2.5 sm:space-y-3">
      {data.map((item, index) => {
        const mappedData = mapFavoritesData(item, t);

        // Handle invalid mapping
        if (!mappedData.id) {
          console.warn('Invalid saved data - missing id:', item);
          return null;
        }

        return (
          <motion.div
            key={mappedData.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: index * 0.05 }}
          >
            <FavoriteResultCard
              title={mappedData.title}
              description={mappedData.description}
              additionalInfo={mappedData.additionalInfo}
              imageUrl={mappedData.animalImageUrl || mappedData.imageUrl}
              postId={mappedData.postId}
              itemType={mappedData.itemType}
              isDeleted={mappedData.isDeleted}
            />
          </motion.div>
        );
      })}
    </div>
  );
};

export default FavoritesList;
